import $ from 'jquery';
import {ajax, notify} from 'linksoft';

/**
 * Returns value representing primary key of the entity displayed in table row.
 */
$.fn.DataTable.Api.register('row().id()', function () {
	const data = this.data();
	return data && data[this.primaryKey()];
});

/**
 * Calls OData API to delete the entity
 */
$.fn.DataTable.Api.register('row().delete()', function () {
	const url = this.init().ajax.url;
	const id = this.id();
	const deleteUrl = `${url}(${id})`;
	ajax({url: deleteUrl, method: 'DELETE'}).done(result => {
		notify.success(this.i18n('notify.delete.success'));
		this.ajax.reload(data => {
			if (data.value.length === 0 && this.page() > 0) {
				this.ajax.reload(); // reload without keeping paging
			}
		}, true);
	}).fail(() => {
		notify.error(this.i18n('notify.delete.failed'));
	});

	$(this.node()).addClass('deleting');
});


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/api/rowExtensions.js